export const daysToSeconds = (days) => {
  return Math.floor(days * (3600 * 24));
}
